import { Upload, Image, message } from "antd";
import { TbPhotoPlus } from "react-icons/tb";
import { useState } from "react";
import "./Upload_Products.scss";

function Upload_Products({ onChangeImages }) {
  const [fileList, setFileList] = useState([null, null, null]);
  const [preview, setPreview] = useState({ open: false, img: "" });

  // Thông tin Cloudinary
  const CLOUDINARY_URL =
    "https://api.cloudinary.com/v1_1/dvdks42uu/image/upload";
  const UPLOAD_PRESET = "Products";

  // Hiển thị preview ảnh
  const handlePreview = (file) => {
    setPreview({ open: true, img: file.url || file.thumbUrl });
  };

  // Nội dung upload slot
  const uploadSlot = () => (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <TbPhotoPlus style={{ fontSize: 24 }} />
      <div style={{ marginTop: 8, fontSize: 12 }}>Tải ảnh lên</div>
    </div>
  );

  return (
    <>
      <div style={{ display: "flex", gap: 16 }}>
        {[0, 1, 2].map((slot) => (
          <Upload
            className="upload-products"
            key={slot}
            listType="picture-card"
            fileList={fileList[slot] ? [fileList[slot]] : []}
            onPreview={handlePreview}
            maxCount={1}
            // Xử lý xóa ảnh
            onRemove={() => {
              const copied = [...fileList];
              copied[slot] = null;
              setFileList(copied);
              onChangeImages(copied.filter(Boolean).map((f) => f.url));
            }}
            // Upload ảnh lên Cloudinary
            customRequest={async ({ file, onSuccess, onError }) => {
              try {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("upload_preset", UPLOAD_PRESET);

                const res = await fetch(CLOUDINARY_URL, {
                  method: "POST",
                  body: formData,
                });
                const data = await res.json();

                const newFile = {
                  uid: file.uid,
                  name: file.name,
                  status: "done",
                  url: data.secure_url,
                };

                const copied = [...fileList];
                copied[slot] = newFile;
                setFileList(copied);

                // Gửi link ảnh lên component cha
                onChangeImages(copied.filter(Boolean).map((f) => f.url));

                onSuccess("ok");
              } catch (err) {
                message.error("Upload ảnh thất bại!");
                console.error(err);
                onError(err);
              }
            }}
          >
            {!fileList[slot] && uploadSlot()}
          </Upload>
        ))}
      </div>

      {/* Preview ảnh */}
      <Image
        style={{ display: "none" }}
        preview={{
          visible: preview.open,
          src: preview.img,
          onVisibleChange: (v) => setPreview({ open: v, img: "" }),
        }}
      />
    </>
  );
}

export default Upload_Products;
